import classNames from "classnames";
import i18next from "i18next";
import React, { PureComponent } from "react";
import { PrimaryButton, SecondaryButton } from "Shared/Buttons";
import LightButton from "Shared/Buttons/LightButton";

export interface WaityButtonProps {
    disabled?: boolean;
    text: string;
    onClick?: () => Promise<boolean>;
    onClickWithoutPromise?: () => void;
    onSuccess?: () => void;
    className?: string;
    buttonComponent?: typeof SecondaryButton | typeof LightButton | typeof PrimaryButton;
}

interface WaityButtonState {
    isBusy: boolean;
    text: string;
}

class WaityButton extends PureComponent<WaityButtonProps, WaityButtonState> {
    private isProcessing: boolean;
    private _isMounted: boolean;
    constructor(props: WaityButtonProps) {
        super(props);
        this.state = {
            isBusy: false,
            text: props.text,
        };
        this._isMounted = false;
    }

    public componentDidMount() {
        this._isMounted = true;
    }

    public componentDidUpdate(prevProps: Readonly<WaityButtonProps>, prevState: Readonly<WaityButtonState>): void {
        if (this.props.text !== prevProps.text) {
            this.setState({ text: this.props.text });
            if (prevState.text === i18next.t("WaityButton.textBtn")) {
                this.setState({ isBusy: false });
            }
        }
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const { className, disabled, onClickWithoutPromise } = this.props;
        const isDisabled = this.state.isBusy || disabled ? { disabled: true } : {};

        const ButtonComponent = this.props.buttonComponent ?? SecondaryButton;

        return (
            <ButtonComponent
                className={classNames(className)}
                onClick={onClickWithoutPromise ? this.onClickWithoutPromise : this.onClick}
                {...isDisabled}
            >
                {this.state.text}
            </ButtonComponent>
        );
    }

    private onClickWithoutPromise = () => {
        if (!this.props.onClickWithoutPromise) {
            return;
        }
        this.setState({
            isBusy: true,
            text: i18next.t("WaityButton.textBtn"),
        });
        this.props.onClickWithoutPromise();
    };

    private onClick = async (e: any) => {
        if (!this.props.onClick) {
            return;
        }
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        this.setState({
            isBusy: true,
            text: i18next.t("WaityButton.textBtn"),
        });

        const success = await this.props.onClick();

        this.isProcessing = false;

        if (this._isMounted) {
            if (!success) {
                this.setState({
                    isBusy: false,
                    text: this.props.text,
                });
                return;
            }

            if (this.props.onSuccess) {
                this.props.onSuccess();
            }
        }
    };
}

export default WaityButton;
